import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Grid} from '@mui/material';
import {
    ToolBarWrapper,
    ToolBarContent,
    ToolBarActions,
    ToolBarItem,
    DisplayCenter,
    ToolBarItemIcon, SallyImage,
} from '../Components/StyledComponents';
import {MdContentCopy} from "react-icons/md";
import {HiOutlineTrash, HiOutlineCamera} from "react-icons/hi2";
import AlertDialog from '../Components/AlertDialog';
import {useDispatch, useSelector} from 'react-redux';
import Box from "@mui/material/Box";
import {
    createMultipleObjects,
    duplicateObject,
    fileUploaderToServer, GetCanvasAtResolution,
    setCanvasBackground, testFileTypes
} from "../utils/helpers";
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import {VerticalAlignBottom, VerticalAlignTop} from "@mui/icons-material";
import {setDeleteImage, setDeleteModal, setLoading} from "../store/reducers/modalToggler";
import {setPanelKey} from "../store/reducers/panleKey";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {RedoIcon, TourIcon} from "../assets/icons";
import {sizeInInches} from "../utils/convertToPixel";
import UndoIcon from '@mui/icons-material/Replay';
import {setUrlsInNewImageList, setUserImagesList} from "../store/reducers/userImagesListSlice";
import {addArtImage} from "../utils/addItems";
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import {showToast} from "../store/reducers/notificationSlice";
import AspectRatio from '@mui/joy/AspectRatio';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import Typography from '@mui/joy/Typography';
import {setActiveObject, setCanvasDimensions} from "../store/reducers/canvasSlice";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import {useTour} from "@reactour/tour";
import Layers from "../Components/Layers";
import Sheet from '@mui/joy/Sheet';
import { styled } from '@mui/joy/styles';

const Item = styled(Sheet)(({ theme }) => ({
    ...theme.typography['body-sm'],
    textAlign: 'center',
    fontWeight: theme.fontWeight.md,
    color: theme.vars.palette.text.secondary,
    border: '1px solid',
    borderColor: theme.palette.divider,
    padding: theme.spacing(1),
    borderRadius: theme.radius.md,
    flexGrow: 1,
}));

const tempArray = [];
function Toolbar({setToggleSubMenu, undo, redo, resizeCanvas, stopEvents, initEvents }) {
    const inputRef = useRef();

    const dispatch = useDispatch()

    const [fontSize, setFontSize] = useState(0);
    const [copy, setCopy] = useState(false);
    const [font, setFont] = useState('Raleway');

    const {canvasDimensions} = useSelector((state) => state.canvas);
    const {activeSetting} = useSelector((state) => state.canvas);
    const {canvas} = useSelector((state) => state.canvas);
    const {activeObject} = useSelector((state) => state.canvas);
    const {deleteModalToggle} = useSelector((state) => state.modalToggle);
    const {deleteImage} = useSelector((state) => state.modalToggle);
    const panelKey = useSelector((state) => state.panelKey).panelKey;
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const imageCollection = useSelector((state) => state.userImagesList).userImagesList;
    const {isLoggedIn} = useSelector((state) => state.loginSlice);

    const [lockMovement, setLockMovement] = useState(false);
    const [uploaderCount, setUploaderCount] = useState(0);
    const [isDivVisible, setIsDivVisible] = useState(false);
    const [selectedOrientation, setSelectedOrientation] = useState(
        activeSheet.size.height > activeSheet.size.width ? 'portrait' : 'landscape'
    );

    useEffect(() => {
        if (activeSetting) {
            const {
                fontFamily,
                fontSize,
                isLockMovement
            } = activeSetting;
            setFont(fontFamily);
            setFontSize(fontSize);
            setLockMovement(isLockMovement)
        }
    }, [activeSetting, activeObject]);

    const deleteObject = () => {
        const activeObjects = canvas.getActiveObjects();
        canvas.discardActiveObject();
        if (activeObjects.length) {
            canvas.remove.apply(canvas, activeObjects);
        }
    };

    function toggleObjectMovement(locked) {
        if (!activeObject) return
        activeObject.lockMovementX = locked;
        activeObject.lockMovementY = locked;
        activeObject.lockRotation = locked;
        activeObject.lockScalingX = locked;
        activeObject.lockScalingY = locked;
        activeObject.lockSkewingX = locked;
        activeObject.lockSkewingY = locked;
        activeObject.hoverCursor = locked ? 'default' : 'move';
        activeObject.setCoords();
        setLockMovement(locked)
        activeObject.set({isLockMovement: locked})
    }

    const sendBackward = () => {

        if (activeObject) {
            canvas.sendBackwards(activeObject, true);
        }

        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
    };

    const sendForward = () => {

        if (activeObject) {
            canvas.bringForward(activeObject, true);
        }

        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
    };

    const ToggleFamilyPanel = () => {
        if (panelKey === 'fontFamily') {
            dispatch(setPanelKey('1'))
        } else {
            setToggleSubMenu(true)
            dispatch(setPanelKey('fontFamily'))
        }
    }

    const openDeleteModal = () => {
        if (activeObject) {
            let dataURL = canvas.getActiveObject().toDataURL({format: 'png', quality: 0.7});
            dispatch(setDeleteModal(true))
            dispatch(setDeleteImage(dataURL))
        }
    }

    const canvasSize = () => {
        let {size} = activeSheet
        return size
    }

    const newInputHandler = async (event) => {
        dispatch(setLoading(true));
        const files = Array.prototype.slice.call(event.target.files);
        setUploaderCount(uploaderCount + 1);
        if (testFileTypes(files)) {
            const newImageList = createMultipleObjects(files.length, uploaderCount);
            dispatch(setUserImagesList([...newImageList, ...imageCollection]));
            tempArray.push(...newImageList, ...imageCollection);
            return new Promise(async (resolve) => {
                const resImageFiles = await fileUploaderToServer(files, uploaderCount, dispatch);
                if (resImageFiles) {
                    addImageToCanvas(resImageFiles[0].CompressedUrl, resImageFiles[0].id)
                    dispatch(setUrlsInNewImageList({resImageFiles, activeSheet}));
                    resolve(true);
                }
            });
        } else {
            dispatch(showToast({message: "Upload type is not allowed!", type: "error"}));
        }
    };

    const addImageToCanvas = (item, id) => {
        dispatch(setLoading(true))
        addArtImage(item, 100, 100, canvas, id, activeSheet).then(() => {
            dispatch(setLoading(false))
        })
    };

    const uploadFile = () => {
        if (!isLoggedIn) {
            alert('Please login first')
            return;
        }
        inputRef.current.click();
    };


    const imageAsBackground = () => {
        if (activeObject && activeObject.type === 'image') {
            dispatch(setLoading(true));
            const imageUrl = activeObject.getSrc();
            setCanvasBackground(canvas, imageUrl, dispatch, activeSheet)
            stopEvents()
            canvas.remove(activeObject)
            dispatch(setActiveObject(null));
            initEvents(canvas)
            canvas.renderAll()
        }
    };

    const resizeChangeHandler = (event, newValue) => {
        let height = canvasSize().height
        let width = canvasSize().width
        if (newValue === 'landscape') {
            GetCanvasAtResolution(Math.max(height, width), Math.min(width, height), canvas, dispatch, resizeCanvas, activeSheet)
        } else if (newValue === 'portrait') {
            GetCanvasAtResolution(Math.min(height, width), Math.max(width, height), canvas, dispatch, resizeCanvas, activeSheet)
        }
        setSelectedOrientation(newValue)
    };

    const handleToggleDiv = () => {
        setIsDivVisible(!isDivVisible);
    };

    useEffect(()=>{
        dispatch(setCanvasDimensions(sizeInInches(activeSheet.size.width, activeSheet.size.height)))
        setSelectedOrientation(activeSheet.size.height > activeSheet.size.width ? 'portrait' : 'landscape')
    },[activeSheet])

    return (
        <>
            <ToolBarWrapper>
                <Grid item md={7} sm={12} xs={12} sx={{mx: 'auto', p: '0px'}}>
                    <ToolBarContent>
                        {activeObject && activeObject.type === 'textbox' ?
                            <DisplayCenter>
                                <ToolBarItem>
                                    <Box gridColumn="span 8">
                                        <div onClick={ToggleFamilyPanel} className="family-select">
                                            <span>{font}</span>
                                            <KeyboardArrowDownIcon/>
                                        </div>
                                    </Box>
                                </ToolBarItem>
                            </DisplayCenter> : ''
                        }
                        <ToolBarActions>
                            <DisplayCenter>
                                <ToolBarItemIcon onClick={undo}>
                                    <UndoIcon/>
                                </ToolBarItemIcon>
                                <ToolBarItemIcon onClick={redo}>
                                    <RedoIcon/>
                                </ToolBarItemIcon>

                                <ToolBarItemIcon onClick={sendForward}>
                                    <VerticalAlignTop color='#38485D' size={17}/>
                                </ToolBarItemIcon>

                                <ToolBarItemIcon onClick={sendBackward}>
                                    <VerticalAlignBottom color='#38485D' size={17}/>
                                </ToolBarItemIcon>

                                <ToolBarItemIcon onClick={() => {
                                    toggleObjectMovement(!lockMovement)
                                }}>
                                    {lockMovement ? <HttpsOutlinedIcon style={{color: '#38485D', height: '20px'}}/> :
                                        <LockOpenOutlinedIcon style={{color: '#38485D', height: '20px'}}/>}
                                </ToolBarItemIcon>

                                <ToolBarItemIcon className={`${copy ? "active-menu-item" : null}`} onClick={() => {
                                    duplicateObject(activeObject, canvas)
                                }}>
                                    <MdContentCopy color='#38485D' size={17}/>
                                </ToolBarItemIcon>
                                <ToolBarItemIcon onClick={openDeleteModal}>
                                    <HiOutlineTrash color='#38485D' size={17}/>
                                </ToolBarItemIcon>
                                <ToolBarItemIcon onClick={uploadFile}>
                                    <HiOutlineCamera color='#38485D' size={25}/>
                                </ToolBarItemIcon>
                                <ToolBarItemIcon onClick={imageAsBackground}>
                                    <WallpaperIcon color={'action'}/>
                                </ToolBarItemIcon>
                                <ToolBarItemIcon onClick={handleToggleDiv}>
                                    <TourIcon />
                                </ToolBarItemIcon>
                                <input
                                    ref={inputRef}
                                    onChange={newInputHandler}
                                    onClick={(e) => (e.target.value = null)}
                                    multiple="multiple"
                                    className="d-none"
                                    type="file"
                                    name="file"
                                    accept="*"
                                />
                            </DisplayCenter>
                        </ToolBarActions>
                    </ToolBarContent>
                </Grid>
                <Box sx={{
                    position:'relative'
                }}>
                <Item sx={{
                    marginRight: '10px',
                    width: 180,
                    padding:'4px',
                    fontSize:16
                }}><span>Size </span>
                    {selectedOrientation === 'portrait'
                        ? `${canvasDimensions.heightInches}' x ${canvasDimensions.widthInches}' (P)`
                        : `${canvasDimensions.widthInches}' x ${canvasDimensions.heightInches}' (L)`
                    }
                </Item>
                <Select
                    sx={{
                        marginRight: '10px',
                        width: 180,
                        position:'absolute',
                        top:0,
                        opacity:0
                    }}
                    value={selectedOrientation}
                    onChange={resizeChangeHandler}
                >
                    <Option value="portrait"><span>Size </span>{canvasDimensions.heightInches}' x {canvasDimensions.widthInches}' (P)</Option>
                    <Option value="landscape"><span>Size </span>{canvasDimensions.widthInches}' x {canvasDimensions.heightInches}' (L)</Option>
                </Select>
                </Box>
                {/*<Layers/>*/}
            </ToolBarWrapper>
            <BasicModalDialog isDivVisible={isDivVisible} setIsDivVisible={setIsDivVisible}/>
            <AlertDialog deletingObj={deleteImage} onChange={deleteObject} OpenAlert={deleteModalToggle}
                         CloseAlert={() => {
                             dispatch(setDeleteModal(false))
                             dispatch(setDeleteImage(''))
                         }}
                         AlertTitle="Are you sure you want to delete this asset?"/>
        </>
    );
}

export default Toolbar;

const BasicModalDialog = ({isDivVisible, setIsDivVisible}) => {
    const { setIsOpen, setCurrentStep } = useTour()
    return (
        <div>
            {isDivVisible && (
                <Card
                    data-resizable
                    sx={{
                        position: 'fixed',
                        right: '1%',
                        p: 2,
                        zIndex: 1000,
                        textAlign: 'center',
                        alignItems: 'center',
                        width: 300,
                        overflow: 'auto',
                        '--icon-size': '100px',
                    }}
                >
                    <CardOverflow variant="solid" color="warning">
                        <AspectRatio
                            variant="outlined"
                            color="warning"
                            ratio="1"
                            sx={{
                                m: 'auto',
                                transform: 'translateY(50%)',
                                borderRadius: '50%',
                                width: 'var(--icon-size)',
                                boxShadow: 'sm',
                                bgcolor: 'background.surface',
                                position: 'relative',
                            }}
                        >
                            <div>
                                <SallyImage src="/images/LeftMenu-Bottom.png"/>
                            </div>
                        </AspectRatio>
                    </CardOverflow>
                    <Typography level="title-lg" sx={{ mt: 'calc(var(--icon-size) / 2)' }}>
                        🎊 Welcome To Editor 🎊
                    </Typography>
                    <CardContent sx={{ maxWidth: '40ch' }}>
                        Quickly explore a brief overview to grasp the essentials of creating your initial design.
                    </CardContent>
                    <CardActions
                        orientation="vertical"
                        buttonFlex={1}
                        sx={{
                            '--Button-radius': '40px',
                            width: 'clamp(min(100%, 160px), 50%, min(100%, 200px))',
                        }}
                    >
                        <Button onClick={()=>{
                            setIsOpen(true)
                            setCurrentStep(0)
                        }} variant="solid" color="warning">
                            Tour Editor
                        </Button>
                        <Button onClick={()=>{setIsDivVisible(false)}} variant="plain" color="neutral">
                            Close
                        </Button>
                    </CardActions>
                </Card>
            )}
        </div>
    );
}